export enum OperatingSystem {
  Mac = 'Mac',
  Windows = 'Windows',
}

export const Platform: Record<OperatingSystem, string[]> = {
  [OperatingSystem.Mac]: ['Mac68K', 'MacIntel', 'Macintosh', 'MacPPC'],
  [OperatingSystem.Windows]: ['Win32', 'Win64', 'WinCE', 'Windows'],
};
